import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export default function rejectRequest(requestId, body) {
  const url = `${process.env.P2C_BASE_URI}/requests/${requestId}/reject`;
  return Client.put(url, body).catch(errorHandler);
}
